export default "/images/25f04678f24268712ca83d6143fc5f84.avif";